import Masonry from 'masonry-layout';
import objectFitImages from 'object-fit-images';

import { View, Utils } from '../vendor/kerneljs';

const MasonryLayout = View.extend({

	events:{

	},

	initialize:function() {
		let settings = {
			itemSelector: ".js--masonry-layout-item",
			gutter: ".js--masonry-layout-sizer-gutter",
			columnWidth: ".js--masonry-layout-sizer-column",
			percentPosition: true
		};

		this.masonryObject = new Masonry( this.el, settings);
		this.masonryObject.layout();

		this.eventEmitter.on('masonry:update', this.layoutUpdate.bind(this) );
		window.addEventListener('masonry:update', this.layoutUpdate.bind(this) );

		objectFitImages();
	},

	layoutUpdate: function () {
		this.masonryObject.layout();
	}

});

(function(){
	function init() {
		Utils.each(Utils.find('.js--masonry-layout'), function(elem) {
			if ( !Utils.hasClass(elem, 'is-bound') ) {
				new MasonryLayout( {el: elem} );
			}
		});
	}

	init();
	window.addEventListener('masonry:init', init);

})();

export default MasonryLayout;